module.exports = __webpack_public_path__ + "img/hr.0b592992.gif";